import BreadCrumb from '../../../component/BreadCrumb';
import { VIEW_SYSTEM_LOGIN_HISTORY } from '../../../constant/ViewConstant';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState, useEffect, useMemo } from 'react';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import PopupRef from '../../../component/PopupRef';
import SelectionBox from '../../../component/SelectionBox';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import TableBox from '../../../component/TableBox';
import ModalRef from '../../../component/ModalRef';
import { useLocation } from 'react-router-dom';
import { actionLoginHistorySearch } from '../../../module/body/system/SystemLoginHistoryModule';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import qs from 'qs';
import NullCheckUtil from '../../../util/NullCheckUtil';
import PathUtil from '../../../util/PathUtil';
import InputBox from '../../../component/InputBox';
import DatePickerBox from '../../../component/DatePickerBox';
import { date2ViewDate, viewDate2SaveDate } from '../../../util/TimeTableUtil';
import { formatDt } from '../../../util/DateTimeUtil';

const ConditionArea = ({ modalRef, popupRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();

    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const [bgnDt, setBgnDt] = useState(formatDt(firstDay));
    const [endDt, setEndDt] = useState(formatDt(lastDay));
    const [userRoleCd, setUserRoleCd] = useState('');
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [userId, setUserId] = useState('');

    const [params, setParams] = useState({});
    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onChangePageInfo,
                onRowDoubleClick,
                params,
            }),
        );

        queryData.bgnDt && setBgnDt(queryData.bgnDt);
        queryData.endDt && setEndDt(queryData.endDt);
        queryData.userId && setUserId(queryData.userId);
        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);
        queryData.userRoleCd && setUserRoleCd(queryData.userRoleCd);
        queryData.userNm && setUserNm(queryData.userNm);

        onClickSearch({
            bgnDt: queryData.bgnDt || bgnDt,
            endDt: queryData.endDt || endDt,
            userId: queryData.userId,
            userUniversityCd: queryData.userUniversityCd,
            userRoleCd: queryData.userRoleCd,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onChangePageInfo,
                onRowDoubleClick,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onRowDoubleClick = () => {};

    const onClickSearch = (params) => {
        setParams(params);
        dispatch(actionLoginHistorySearch({ params }));
        PathUtil.pushState(location.pathname, params);
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                bgnDt,
                endDt,
                userId,
                userUniversityCd,
                userRoleCd,
                userNm,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'loginDttm',
                headerName: '로그인일시',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userRoleCd',
                headerName: '역할',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.USER_ROLE, params.row.userRoleCd),
            },
            {
                field: 'userUniversityCd',
                headerName: '대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => {
                    if (NullCheckUtil.isNotEmpty(params.row.userUniversityCd)) {
                        return CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd);
                    } else {
                        return '';
                    }
                },
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userId',
                headerName: '사용자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'connIp',
                headerName: '접속IP',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <DatePickerBox
                                        title='시작일자'
                                        value={date2ViewDate(bgnDt)}
                                        size='medium'
                                        onChange={(e) => setBgnDt(viewDate2SaveDate(e.target.value))}
                                    />
                                    <DatePickerBox
                                        title='종료일자'
                                        value={date2ViewDate(endDt)}
                                        size='medium'
                                        onChange={(e) => setEndDt(viewDate2SaveDate(e.target.value))}
                                    />
                                    <SelectionBox
                                        title='역할'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_ROLE)}
                                        value={userRoleCd}
                                        onChange={(e) => setUserRoleCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='대학'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                        value={userUniversityCd}
                                        onChange={(e) => setUserUniversityCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <InputBox
                                        title='이름'
                                        value={userNm}
                                        onChange={(e) => setUserNm(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                        size='medium'
                                    />
                                    <InputBox
                                        title='사용자ID'
                                        value={userId}
                                        onChange={(e) => setUserId(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            bgnDt,
                                            endDt,
                                            userId,
                                            userUniversityCd,
                                            userRoleCd,
                                            userNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className='board-row'>
                        <div className='lec-check-box mt16'>
                            <div className='form-box-container'>
                                <DatePickerBox
                                    title='시작일자'
                                    value={date2ViewDate(bgnDt)}
                                    size='medium'
                                    onChange={(e) => setBgnDt(viewDate2SaveDate(e.target.value))}
                                />
                                <DatePickerBox
                                    title='종료일자'
                                    value={date2ViewDate(endDt)}
                                    size='medium'
                                    onChange={(e) => setEndDt(viewDate2SaveDate(e.target.value))}
                                />
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>로그인 이력</h3>
                </div>
            </div>
        </>
    );
};

const SystemLoginHistoryView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    <h2 className='con-title'>{VIEW_SYSTEM_LOGIN_HISTORY.title}</h2>
                    <p className='con-title-p'>{VIEW_SYSTEM_LOGIN_HISTORY.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea modalRef={modalRef} popupRef={popupRef} />
                <TableBox defaultWide={false} />
            </div>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </section>
    );
};

export default SystemLoginHistoryView;
